import React, { Fragment } from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import { getUserFullName, getUserInitials } from 'helpers/getUserUIData'
import UserAvatarWithStats from 'app/components/UserAvatarWithStats/UserAvatarWithStats'
import {
  ACTION_NAMES,
  EMOJIS,
  PROTRACK_ACTIONS,
  ACTION_NAME_ACHIEVEMENT,
  ACTION_NAME_BADGE_ACHIEVEMENT,
} from 'app/constants/feed'
import TagIconSmall from 'app/components/SVGS/TagIconSmall'
import PeerInvitationAcceptedIcon from 'app/components/SVGS/PeerInvitationAcceptedIcon'

import './styles.scss'
const bc = 'notification-list-item'

const NotificationsListItem = ({ t, notification }) => {
  const isReaction = notification.emoji
  const isPeerInviteAccepted = notification.peerInvitedBy

  const userData = notification.user

  const { firstName, lastName, avatar, email } = userData

  const initials = getUserInitials(firstName, lastName, email)
  const fullName = getUserFullName(firstName, lastName)

  const { emoji, event, activityUserStory, timestamp } = notification

  const icon = EMOJIS.find(item => item.name === emoji)
  let eventName = event && event.name
  if (eventName === ACTION_NAME_BADGE_ACHIEVEMENT) {
    eventName = ACTION_NAME_ACHIEVEMENT
  }

  let notificationTitle

  if (isReaction) {
    notificationTitle = ' likes '
  } else if (isPeerInviteAccepted) {
    notificationTitle = ' accepted invite is on your team '
  } else {
    notificationTitle = ' tagged '
  }

  const renderNotificationByType = (event, activityUserStory) => {
    if (eventName === ACTION_NAME_ACHIEVEMENT || eventName === ACTION_NAME_BADGE_ACHIEVEMENT) {
      return <span className={`${bc}__action`}>{`your ${event.name}`}</span>
    }

    if (event && event.id && eventName && ACTION_NAME_ACHIEVEMENT !== eventName) {
      return (
        <span className={`${bc}__action`}>
          {PROTRACK_ACTIONS.indexOf(eventName) === -1
            ? `${ACTION_NAMES[eventName].title} "${event.activityName}"`
            : `${ACTION_NAMES[eventName].title}`}
          {` ${event.subject}`}
        </span>
      )
    }

    if (isPeerInviteAccepted) {
      return null
    }

    return (
      <Fragment>
        <span className={`${bc}__question`}>{`${activityUserStory.activity.question} `}</span>
        <span className={`${bc}__story`} dangerouslySetInnerHTML={{ __html: activityUserStory.story }} />
      </Fragment>
    )
  }

  return (
    <div className={bc}>
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__icon`}>
          <UserAvatarWithStats
            isReactionBoard
            avatar={avatar}
            initials={initials}
            circleProps={{
              cx: 20,
              cy: 20,
              strokeWidth: 2,
              r: 19,
            }}
          />
          <div className={`${bc}__emoji`}>
            {isReaction && icon && React.createElement(icon.icon, { width: 16, height: 16 })}
            {!isReaction && !isPeerInviteAccepted && <TagIconSmall />}
            {isPeerInviteAccepted && (
              <div className={`${bc}__emoji--peer`}>
                <PeerInvitationAcceptedIcon />
              </div>
            )}
          </div>
        </div>
        <div className={`${bc}__message`}>
          <span className={`${bc}__name`}>{t(fullName)}</span>
          <span className={`${bc}__reaction`}>{t(notificationTitle)}</span>
          {renderNotificationByType(event, activityUserStory)}
          <div className={`${bc}__date`}>{moment(timestamp).fromNow()}</div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(NotificationsListItem)
